// extracted by mini-css-extract-plugin
export default {"fieldset":"VariationForm_fieldset__FML7N","date-fieldset":"VariationForm_date-fieldset__+rCmq"};